var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmojiicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.00931006 17.9988C0.00931006 15.5335 0.0291904 13.0682 0.000273538 10.6029C-0.0141849 9.3646 0.547887 8.50054 1.74071 7.8952C6.61862 5.42178 11.4857 2.9321 16.3473 0.432645C17.4697 -0.145028 18.5342 -0.143401 19.6565 0.432645C24.5182 2.9321 29.3852 5.42178 34.2631 7.8952C35.456 8.50054 36.0054 9.36786 36 10.6062C35.9783 15.5368 35.9783 20.4657 36 25.3962C36.0054 26.6346 35.4523 27.5003 34.2595 28.1056C29.3834 30.5807 24.5145 33.0687 19.6529 35.5682C18.5306 36.1458 17.4643 36.1426 16.3437 35.5665C11.4821 33.0671 6.61501 30.5774 1.73709 28.104C0.544272 27.4986 -0.0141849 26.6329 0.000273538 25.3946C0.0291904 22.9277 0.00931006 20.4624 0.00931006 17.9988Z",
    fill: "url(#paint0_linear_1165_127)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1165_127)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.6853 11.924C17.0101 10.5932 13.2212 11.9582 11.5464 15.1977C9.90293 18.3726 10.9894 22.2357 14.0684 24.1673C17.1082 26.0722 21.3796 25.5741 23.882 22.1483C24.2978 22.5589 24.7724 22.8745 25.3803 23.0684C24.0075 25.0456 22.1719 26.3232 19.8185 26.8023C14.0096 27.9962 8.75762 23.6236 9.00865 17.8403C9.25967 12.1901 15.2961 8.20913 20.7677 10.0837C21.1285 10.2091 21.2109 10.3346 21.054 10.6882C20.8854 11.0646 20.8148 11.4791 20.6853 11.924Z",
    fill: "#313131"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1447 17.7644C25.9761 17.7644 25.8113 17.7682 25.6427 17.7644C25.2622 17.753 25.0818 17.5705 25.0622 17.1903C25.0112 16.1865 25.3564 15.3462 26.0977 14.6617C26.5566 14.2397 27.039 13.8443 27.494 13.4184C27.8784 13.0572 28.047 12.6123 27.9451 12.0876C27.8745 11.7302 27.7019 11.426 27.3371 11.3043C26.686 11.0838 26.0231 11.0724 25.3917 11.369C24.9131 11.5933 24.6856 11.9887 24.6856 12.5059C24.6856 12.9355 24.4699 13.137 24.0306 13.1142C23.8659 13.1066 23.6972 13.1066 23.5286 13.1142C22.6186 13.156 22.3244 13.1332 22.5441 11.9165C22.901 9.94312 24.7523 8.76441 26.9606 9.03437C28.302 9.19787 29.3806 9.73019 29.8944 11.023C30.4279 12.3728 30.1925 13.6085 29.2355 14.715C28.8158 15.2017 28.302 15.5933 27.8156 16.0116C27.5371 16.2473 27.2744 16.4868 27.2665 16.9051C27.2469 17.715 27.1841 17.7568 26.3683 17.7606C26.2938 17.7644 26.2193 17.7644 26.1447 17.7644Z",
    fill: "#313131"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9157 19.5439C18.8453 19.5744 19.7435 19.7455 20.5476 20.2474C21.081 20.582 21.2418 21.0915 20.9712 21.5325C20.6888 21.9812 20.1945 22.042 19.6101 21.7303C18.4844 21.1257 17.347 21.1333 16.2252 21.7341C15.6251 22.0535 15.1779 21.9964 14.8759 21.5287C14.5621 21.042 14.7073 20.5744 15.3074 20.2208C16.1075 19.7531 16.9861 19.5782 17.9157 19.5439Z",
    fill: "#313131"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1702 16.3343C22.1663 17.1328 21.4877 17.7792 20.6797 17.7602C19.8835 17.7412 19.252 17.1138 19.2442 16.3343C19.2402 15.532 19.8953 14.8818 20.7072 14.8818C21.5191 14.8818 22.1741 15.532 22.1702 16.3343Z",
    fill: "#313131"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6485 16.3081C13.6564 15.5096 14.3271 14.8632 15.139 14.8822C15.947 14.9013 16.6059 15.5743 16.5824 16.3613C16.5628 17.1256 15.896 17.7606 15.1115 17.7606C14.2957 17.7606 13.6407 17.1104 13.6485 16.3081Z",
    fill: "#313131"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2189 21.4181C25.458 21.4105 24.8343 20.7983 24.8461 20.0645C24.8579 19.3268 25.4894 18.7337 26.2542 18.7413C27.023 18.7489 27.6309 19.3496 27.6231 20.0949C27.6113 20.8401 26.9916 21.4257 26.2189 21.4181Z",
    fill: "#313131"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1165_127",
    x1: 35.225,
    y1: 29.662,
    x2: 2.26761,
    y2: 6.12913,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.128199,
    stopColor: "#FFDBB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.942149,
    stopColor: "#FFF4D7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1165_127"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.1765,
    height: 18,
    fill: "white",
    transform: "translate(9 9)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmojiicon);
export default __webpack_public_path__ + "static/media/emojiicon.ae46de9fc72ef47c3a0a236d7f6b06f0.svg";
export { ForwardRef as ReactComponent };